module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth6.e9bda4d7.png";